import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { useState } from "react";
import { IMAGES, COLLEGE } from "../../lib/constants";

const VideoTour = () => {
  const [playing, setPlaying] = useState(false);
  return (
    <section className="py-20 md:py-28 bg-megha-bg" data-testid="section-video-tour">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">Campus Tour</div>
          <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
            Take a virtual walk through {COLLEGE.short}.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="relative aspect-video rounded-3xl overflow-hidden shadow-2xl shadow-blue-900/20 group cursor-pointer"
          onClick={() => setPlaying(true)}
          data-testid="video-tour-card"
        >
          {!playing ? (
            <>
              <img src={IMAGES.videoPoster} alt="Campus tour" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-megha-primary/70 via-megha-primary/30 to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-megha-highlight flex items-center justify-center shadow-2xl shadow-yellow-500/40 group-hover:scale-110 transition-transform animate-pulse-glow">
                  <Play className="w-9 h-9 text-megha-primary ml-1" fill="currentColor" />
                </div>
              </div>
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <div className="text-xs tracking-[0.18em] uppercase text-blue-100/90 mb-1">2 min walkthrough</div>
                <div className="font-heading font-extrabold text-2xl md:text-3xl">Explore the MIETW campus</div>
              </div>
            </>
          ) : (
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
              title="Campus tour"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default VideoTour;
